import { Typography } from '@lightbeamai/design-system'
import React from 'react'
import { useIntl } from 'react-intl'
import { TooltipProps } from 'recharts'

interface CustomTooltipProps extends TooltipProps<number, string> {
  title?: string
}

const RiskScoreCustomTooltip = (props: CustomTooltipProps) => {
  const intl = useIntl()
  const { active, payload } = props

  if (active && payload && payload.length) {
    return (
      <div className="colored-custom-tooltip">
        {payload.map((item: any) => {
          const label = item.payload.name
          return (
            <div className="tooltip-with-title" key={item.dataKey}>
              <div className="tooltip-title-container">
                <Typography as="span" color="primary" variant="baseMinus2" className="xs-p-0">
                  {intl.formatMessage({ id: 'dataSources.widget.riskScore.graph.xAxis' })}
                </Typography>
                :
                <Typography
                  as="span"
                  color="primary"
                  className="title-text"
                  type="medium"
                  variant="baseMinus2"
                >
                  {label}
                </Typography>
              </div>
              <div className="tooltip-text xs-py-8">
                <Typography as="div" color="secondary" variant="baseMinus2">
                  {intl.formatMessage({ id: 'objects' })}
                </Typography>
                <div className="tooltip-values">
                  <Typography color="primary" variant="baseMinus2" type="medium">
                    {intl.formatNumber(item.payload.totalObjects || 0, { notation: 'compact' })}
                  </Typography>
                </div>
              </div>
            </div>
          )
        })}
      </div>
    )
  } else {
    return <></>
  }
}

export default RiskScoreCustomTooltip
